import { combineReducers } from 'redux';

import { createResumeReducer as createResume } from 'src/components/Profile/CreateResume/reducer';
import { resumeReducer as resume } from 'src/components/Profile/Resume/reducer';
import { profileReducer as profile } from 'src/components/Profile/reducer';
import { routerReducer as router } from 'src/components/Router/reducer';
import { reducer as blend } from 'src/modules/redux-blend';

import { formsReducer as forms } from './forms';
import { loadingReducer as loading } from './loading';
import { syncingReducer as syncing } from './syncing';
import { userReducer as user } from './user';

export const rootReducer = combineReducers({
  user,
  syncing,
  forms,
  loading,
  profile,
  resume,
  router,
  blend,
  createResume,
});
